import type { QueryClient } from '@tanstack/react-query';
import { orpc } from '@/api/rpc/client';

const overrideQueryKeys = {
  demand: [orpc.procurement.demandOverrides.key()],
  policy: [],
  leadTime: [
    orpc.procurement.leadTimeOverrides.key(),
    orpc.procurement.leadTimes.key(),
    orpc.procurement.supplierProducts.key(),
  ],
  factor: [orpc.procurement.forecastFactors.key()],
  outlier: [orpc.procurement.forecastOutlierRules.key()],
};

/** Refresh the current policy and forecast readers after any override change. */
export function invalidatePlanningOverride(
  queryClient: QueryClient,
  kind: keyof typeof overrideQueryKeys,
) {
  for (const queryKey of [
    ...overrideQueryKeys[kind],
    orpc.procurement.inventoryPolicyOverrides.key(),
    orpc.procurement.replenishmentSuggestions.key(),
    orpc.procurement.overrides.key(),
    orpc.procurement.forecastDetail.key(),
    orpc.procurement.forecastRuns.key(),
    // The infinite demand grid uses a custom key, separate from the oRPC reads.
    ['procurement', 'demandMatrix'],
  ]) {
    void queryClient.invalidateQueries({ queryKey });
  }
}
